const actions = {
  GET_DATA_HELP_CHAIN_REQUEST: "GET_DATA_HELP_CHAIN_REQUEST",
  GET_DATA_HELP_CHAIN_SUCCESS: "GET_DATA_HELP_CHAIN_SUCCESS",

  GET_DATA_HELP_STORE_REQUEST: "GET_DATA_HELP_STORE_REQUEST",
  GET_DATA_HELP_STORE_SUCCESS: "GET_DATA_HELP_STORE_SUCCESS",

  GET_DATA_HELP_ERROR: "GET_DATA_HELP_ERROR",

  GET_FILE_REQUEST: "HELP/GET_FILE_REQUEST",
  GET_FILE_SUCCESS: "HELP/GET_FILE_SUCCESS",
  GET_FILE_ERROR: "HELP/GET_FILE_ERROR",

  GET_RANKING_AGGREGATE_REQUEST: "GET_RANKING_AGGREGATE_REQUEST",
  GET_RANKING_AGGREGATE_SUCCESS: "GET_RANKING_AGGREGATE_SUCCESS",
  GET_RANKING_AGGREGATE_ERROR: "GET_RANKING_AGGREGATE_ERROR",

  GET_FILE_RANKING_REPORT_REQUEST: "GET_FILE_RANKING_REPORT_REQUEST",
  GET_FILE_RANKING_REPORT_SUCCESS: "GET_FILE_RANKING_REPORT_SUCCESS",
  GET_FILE_RANKING_REPORT_ERROR: "GET_FILE_RANKING_REPORT_ERROR",

  CREATE_CRON_RANKING_REPORT_REQUEST: "CREATE_CRON_RANKING_REPORT_REQUEST",
  CREATE_CRON_RANKING_REPORT_SUCCESS: "CREATE_CRON_RANKING_REPORT_SUCCESS",
  CREATE_CRON_RANKING_REPORT_ERROR: "CREATE_CRON_RANKING_REPORT_ERROR",

  GET_CRON_RANKING_REPORT_REQUEST: "GET_CRON_RANKING_REPORT_REQUEST",
  GET_CRON_RANKING_REPORT_SUCCESS: "GET_CRON_RANKING_REPORT_SUCCESS",
  GET_CRON_RANKING_REPORT_ERROR: "GET_CRON_RANKING_REPORT_ERROR",

  GET_FILE_RANKING_CRON_REPORT_REQUEST: "GET_FILE_RANKING_CRON_REPORT_REQUEST",
  GET_FILE_RANKING_CRON_REPORT_SUCCESS: "GET_FILE_RANKING_CRON_REPORT_SUCCESS",
  GET_FILE_RANKING_CRON_REPORT_ERROR: "GET_FILE_RANKING_CRON_REPORT_ERROR",

  getStoreData: (payload) => ({
    type: actions.GET_DATA_HELP_STORE_REQUEST,
    payload,
  }),

  getChainData: (payload) => ({
    type: actions.GET_DATA_HELP_CHAIN_REQUEST,
    payload,
  }),

  getFileRequest: () => ({
    type: actions.GET_FILE_REQUEST,
  }),

  createRankingAggregateData: (payload) => ({
    type: actions.GET_RANKING_AGGREGATE_REQUEST,
    payload,
  }),

  getFileRankingReport: (payload) => ({
    type: actions.GET_FILE_RANKING_REPORT_REQUEST,
    payload,
  }),

  createRankingCronReport: (payload) => ({
    type: actions.CREATE_CRON_RANKING_REPORT_REQUEST,
    payload,
  }),

  getRankingCronReport: (payload) => ({
    type: actions.GET_CRON_RANKING_REPORT_REQUEST,
    payload,
  }),

  getFileRankingCronReport: (payload) => ({
    type: actions.GET_FILE_RANKING_CRON_REPORT_REQUEST,
    payload,
  }),

};

export default actions;
